import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import './switch.css';

export default class Switch extends React.PureComponent{
    constructor(props){
        super(props);

        this.state={checked:this.props.checked}
        this.toggle=this.toggle.bind(this);
    }
    static getDerivedStateFromProps(nextProps){
        if ('checked' in nextProps){
            return {
                checked: !!nextProps.checked
            }
        }
        return null;
    }
    toggle(ev){
       if(this.props.disabled) return;
       if(this.props.preventDefault){
            ev.preventDefault();
            ev.stopPropagation();
       } 
       this.setState({
            checked: !this.state.checked
        });
        if(this.props.onChange) this.props.onChange(!this.state.checked)
    }
    render(){
        const { className } = this.props;
        let switchClass=classNames({
            [className]: !!className,
            "kui-switch":true,
            "kui-switch--disabled":this.props.disabled,
            "kui-switch--checked":this.state.checked
        })
        return(
            <span onClick={this.toggle} className={switchClass}/>
        )
    }
}

Switch.propTypes={
    className: PropTypes.string,
    checked: PropTypes.bool,
    disabled:PropTypes.bool,
    preventDefault:PropTypes.bool
}


// WEBPACK FOOTER //
// ./src/components/Switch/index.js